import React, { useState, useEffect, useRef, useContext } from 'react';
import { PerspectiveCamera, PresentationControls } from '@react-three/drei';

import Homex from './Homex';
import AppContext from '../../components/context/AppContext';
import { Canvas } from '@react-three/fiber';
import { AdaptiveDpr, AdaptiveEvents } from '@react-three/drei';

import { isMobile } from 'react-device-detect';

//prettier-ignore

function MyScene(props) {
  const canvasRef = useRef(null);
 
  const scrollRef = useRef(null);
  const [size, setSize] = useState(16);
  const { windowsWidth } = useContext(AppContext);



 
 
  useEffect(() => {
    const mainCounter = document.querySelector("#idInteractive");
    const result = mainCounter.getBoundingClientRect();

   
    if (result.width  < 481) setSize(16);
    else if (result.width  >= 480 && result.width  < 640) setSize(18);
    else if (result.width  >= 640 && result.width  < 768) setSize(16);
    else if (result.width  >= 768 && result.width  < 1024) setSize(25);
    else if (result.width  >= 1024 && result.width  < 1200) setSize(20);
    else if (result.width  >= 1200 && result.width  < 1440) setSize(18);
    else if (result.width  >= 1440 && result.width  < 2000) setSize(15);
    else if (result.width  >= 2000) setSize(17);
  }, []);



  const checkMobile = () => {
    const mainCounter = document.querySelector("#idInteractive");
    const result = mainCounter.getBoundingClientRect();

    if (result.width  < 481) setSize(16);
    else if (result.width  >= 480 && result.width  < 640) setSize(18);
    else if (result.width  >= 640 && result.width  < 768) setSize(16);
    else if (result.width  >= 768 && result.width  < 1024) setSize(25);
    else if (result.width  >= 1024 && result.width  < 1200) setSize(20);
    else if (result.width  >= 1200 && result.width  < 1440) setSize(18);
    else if (result.width  >= 1440 && result.width  < 2000) setSize(15);
    else if (result.width  >= 2000) setSize(17);

  };

  useEffect(() => {
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);


 




  return (
    
      <Canvas id="canvasi" ref={scrollRef}   style={{  pointerEvents : isMobile ? "auto" : "auto" ,  }}  gl={{ preserveDrawingBuffer: true }}>
       
          <spotLight intensity={1} position={[71, 258, -144]} castShadow shadow-bias={-0.01} />
          <directionalLight intensity={0.3} />
          <hemisphereLight intensity={0.3} />

          <AdaptiveDpr pixelated />
          <AdaptiveEvents />
          {/*Camera---------------------------------------------------*/}
          <PerspectiveCamera makeDefault={props.cameraButton === "cameraA" ? true : false} far={10000000000} near={0.01} fov={size} position={[24.17, 46, -44]} rotation={[-2.35, 0.37, 2.8]} />

          <PerspectiveCamera makeDefault={props.cameraButton === "cameraB" ? true : false} far={10000000000} near={0.01} fov={size} position={[24.17, 60.99, -30.73]} rotation={[-2.04, 0.34, 2.56]} />

          {/*Meshs ---------------------------------------------------*/}
          <PresentationControls
            enabled={true} // the controls can be disabled by setting this to false
            global={true} // Spin globally or by dragging the model
            cursor={true} // Whether to toggle cursor style on drag
            snap={{ mass: 4, tension: 300 }}
            config={{ mass: 2, tension: 500 }}
            speed={2.5}
            //zoom={5}
            rotation={[0, 0, 0]}
            //   azimuth={[0, 0]} // Vertical limits
            polar={[0, 0]} // Horizontal limits
          >
            {
               <Homex  {...props} scale={1} position={[0, 0, 0]} speed={ isMobile ? 0.005 : 0.001} />
            }
           
           
          </PresentationControls>
         
      
      </Canvas>
  
  );
}

export default MyScene;
//   <Environment preset="city" />

/*
      <PresentationControls
        enabled={true} // the controls can be disabled by setting this to false
        global={true} // Spin globally or by dragging the model
        cursor={true} // Whether to toggle cursor style on drag
        snap={{ mass: 4, tension: 300 }}
        config={{ mass: 2, tension: 500 }}
        speed={0.5}
        //zoom={5}
        rotation={[0, 0, 0]}
        //   azimuth={[0, 0]} // Vertical limits
        polar={[0, 0]} // Horizontal limits
      >
       
      
      </PresentationControls>
*/

// style={{ backgroundColor: canvasBackgroundColor }}
